import { render } from "./errors.vue?vue&type=template&id=089805bb&scoped=true"
import script from "./errors.vue?vue&type=script&lang=js"
export * from "./errors.vue?vue&type=script&lang=js"

import "./errors.vue?vue&type=style&index=0&id=089805bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089805bb"]])

export default __exports__